module.exports = __webpack_public_path__ + "img/ThreeAxleTractorFourAxleSemitrailer.c6b9f3cc.svg";